<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">

			<el-form-item label="图标:">
				<el-upload class="avatar-uploader" :action="this.$http_host + '/Admin/Lottery/uploadIcon'" :headers="headers" :show-file-list="false"
					:on-success="UploadSuccess"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
				  <img v-if="ruleForm.lottery_icon" :src="ruleForm.lottery_icon" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>
			
			<div style="display: flex; flex-direction: row; align-items: center;">
				<el-form-item label="彩种名称" prop="lottery_name">
					<el-input style="width: 200px;" size="small" v-model="ruleForm.lottery_name" placeholder="彩种名称"></el-input>
				</el-form-item>
				<el-form-item label="提前封盘:" prop="ahead_time">
					<el-input style="width: 200px;" size="small" v-model="ruleForm.ahead_time" placeholder="提前封盘(分钟)"></el-input>
				</el-form-item>
			</div>
			<div style="display: flex; flex-direction: row; align-items: center;">
				<el-form-item label="最低下注" prop="low_limit">
					<el-input style="width: 200px;" size="small" v-model="ruleForm.low_limit" placeholder="提前封盘(分钟)"></el-input>
				</el-form-item>
				<el-form-item label="彩种标识:" prop="lottery_sign">
					<el-input style="width: 200px;" size="small" v-model="ruleForm.lottery_sign" placeholder="彩种标识"></el-input>
				</el-form-item>
			</div>
			
			<div style="display: flex; flex-direction: row; align-items: center;">
				<el-form-item label="彩种状态" prop="open_status">
					<el-switch v-model="ruleForm.open_status" active-color="#3399ff" inactive-color="#EFEFEF" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="奖金优化" prop="optimize_status">
					<el-switch v-model="ruleForm.optimize_status" active-color="#3399ff" inactive-color="#EFEFEF" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="合买开关" prop="union_buy">
					<el-switch v-model="ruleForm.union_buy" active-color="#3399ff" inactive-color="#EFEFEF" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
			</div>
			<div style="display: flex; flex-direction: row; align-items: center;">
				<el-form-item label="跟单开关" prop="follow_buy">
					<el-switch v-model="ruleForm.follow_buy" active-color="#3399ff" inactive-color="#EFEFEF" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="时间开关" prop="time_status">
					<el-switch v-model="ruleForm.time_status" active-color="#3399ff" inactive-color="#EFEFEF" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="平台开关" prop="plat_status">
					<el-switch v-model="ruleForm.plat_status" active-color="#3399ff" inactive-color="#EFEFEF" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
			</div>
			 <el-form-item label="周一至周五">
			    <el-col :span="5">
			      <el-input size="small" v-model="ruleForm.start_time" placeholder="11:00"></el-input>
			    </el-col>
			    <el-col class="line" :span="1"> 至</el-col>
			    <el-col :span="5">
			      <el-input size="small" v-model="ruleForm.ended_time" placeholder="22:00"></el-input>
			    </el-col>
			  </el-form-item>
			  
			  <el-form-item label="周六至周日">
			     <el-col :span="5">
			       <el-input size="small" v-model="ruleForm.start_time1" placeholder="11:00"></el-input>
			     </el-col>
			     <el-col class="line" :span="1"> 至</el-col>
			     <el-col :span="5">
			       <el-input size="small" v-model="ruleForm.ended_time1" placeholder="23:00"></el-input>
			     </el-col>
			   </el-form-item>
			<el-form-item label="排序:">
				<el-input style="width: 200px;" size="small" v-model="ruleForm.sorts" placeholder="排序"></el-input>
			</el-form-item>
			
			
			
			<el-form-item>
				<el-button style="width: 250px;" type="primary" @click="submitForm('ruleForm')">立即添加</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				ruleForm: {
					lottery_name:'',
					lottery_icon:'',
					lottery_icon_short:'',
					ahead_time:'',
					open_status:1,
					optimize_status:1,
					time_status:0,
					union_buy:1,
					follow_buy:1,
					low_limit:10,
					plat_status:1,
					start_time:'11:00',
					ended_time:'22:00',
					start_time1:'11:00',
					ended_time1:'23:00',
					lottery_sign:'',
				},
				rules: {
					lottery_icon: [{required: true, message: '请输入上传图标', trigger: 'blur'}],
					lottery_name: [{required: true, message: '请输入彩种名称', trigger: 'blur'}],
					ahead_time: [{required: true, message: '请输入封盘时间', trigger: 'blur'}],
					low_limit: [{required: true, message: '请输入最低下注', trigger: 'blur'}],
					lottery_sign: [{required: true, message: '请输入彩种标识', trigger: 'blur'}],
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				if(res.code == 200)
				{
					this.ruleForm.lottery_icon = res.data.url;
					this.ruleForm.lottery_icon_short = res.data.shortUrl;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Lottery/addLottery", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '添加成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 80px;
	    height: 80px;
	    line-height: 80px;
	    text-align: center;
		border: solid 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 80px;
	    height: 80px;
	    display: block;
	  }
</style>